import { takeLatest, put, call } from 'redux-saga/effects';

import { listImplantacaoEstoque } from '../service';
import {
  TABLE_IMPLANTACAO_ESTOQUE,
  TABLE_IMPLANTACAO_ESTOQUE_PENDING,
  TABLE_IMPLANTACAO_ESTOQUE_SUCCESS,
  TABLE_IMPLANTACAO_ESTOQUE_FAILURE
} from '../actionTypes';

function* sagaListImplantacaoEstoque(action) {
  yield put({ type: TABLE_IMPLANTACAO_ESTOQUE_PENDING })

  try {
    const table = yield call(listImplantacaoEstoque, action.args)
    yield put({ type: TABLE_IMPLANTACAO_ESTOQUE_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_IMPLANTACAO_ESTOQUE_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListImplantacaoEstoque() {
  yield takeLatest(TABLE_IMPLANTACAO_ESTOQUE, sagaListImplantacaoEstoque)
}